import Resource from './resource.js';

export default class Properties extends Resource {
    async postAttendance(propertyId) {
        return this.httpPost("properties/" + propertyId, {}, true);
    }
}
